export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_00.43a22e02.jpg";